import React from "react";
import PropTypes from "prop-types";

import Skeleton from "@material-ui/lab/Skeleton";
import { Table } from "semantic-ui-react";

import { useBooleanState } from "hooks";

import { useGetPracticeInfo } from "./hooks";
import { EditPracticeModal, PracticeMenu } from "./components";

function PracticeInformationBody({ onChange }) {
  const [isModalOpen, openModal, closeModal] = useBooleanState();
  const { loading, info, error } = useGetPracticeInfo();

  if (loading) {
    return (
      <Table.Body data-test="practice-information-loading-body">
        <Table.Row>
          <Table.Cell width={7}>
            <Skeleton variant="text" />
          </Table.Cell>
          <Table.Cell width={7}>
            <Skeleton variant="text" />
          </Table.Cell>
          <Table.Cell width={2}>
            <Skeleton variant="text" />
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    );
  }

  if (error || !info.practice) {
    return (
      <Table.Body>
        <Table.Row>
          <Table.Cell>
            {error ||
              "We could not find a practice associated with your account"}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    );
  }

  return (
    <React.Fragment>
      <Table.Body data-test="practice-information-body">
        <Table.Row>
          <Table.Cell width={7}>{info.practice?.name}</Table.Cell>
          <Table.Cell width={7}>{info.practice?.accountOwner?.name}</Table.Cell>
          <Table.Cell width={2}>
            {info.isAccountOwner && info.practice?.isBillable && (
              <PracticeMenu onEditPractice={openModal} />
            )}
          </Table.Cell>
        </Table.Row>
      </Table.Body>

      {isModalOpen && (
        <EditPracticeModal
          practice={info.practice}
          accountOwner={info.practice?.accountOwner}
          onSubmit={(data) => {
            onChange(
              "Changes to your practice are being processed and will be reflected shortly."
            );
          }}
          onClose={closeModal}
        />
      )}
    </React.Fragment>
  );
}

PracticeInformationBody.propTypes = { onChange: PropTypes.func.isRequired };
PracticeInformationBody.defaultProps = {};

export default PracticeInformationBody;
